import intlMessageDE from '../../strings/de.json';
import intlMessageEN from '../../strings/en.json';
import intlMessageES from '../../strings/es.json';
import intlMessageFR from '../../strings/fr.json';
import intlMessageHI from '../../strings/hi.json';
import intlMessageIT from '../../strings/it.json';
import intlMessageJP from '../../strings/jp.json';
import intlMessagePT from '../../strings/pt.json';
import intlMessageRO from '../../strings/ro.json';
import intlMessageAR from '../../strings/ar.json';
import intlMessageTR from '../../strings/tr.json';
import intlMessageNL from '../../strings/nl.json';
import {DataHandler} from "@amzn/dolphin-web-framework";

export function getLocale() {
    switch (DataHandler.getUserLocale()) {
        case "de":
        case "de-CH":
        case "de-AT":
        case "de-LU":
        case "de-LI":
            return "de"
        case "es":
        case "es-AR":
        case "es-GT":
        case "es-CR":
        case "es-PA":
        case "es-DO":
        case "es-MX":
        case "es-VE":
        case "es-CO":
        case "es-PE":
        case "es-EC":
        case "es-CL":
        case "es-UY":
        case "es-PY":
        case "es-BO":
        case "es-SV":
        case "es-HN":
        case "es-NI":
        case "es-PR":
            return "es"
        case "fr":
        case "fr-BE":
        case "fr-CA":
        case "fr-CH":
        case "fr-LU":
            return "fr"
        case "hi":
        case "hi-IN":
            return "hi"
        case "it":
        case "it-CH":
            return "it"
        case "ja":
        case "jp":
            return "ja"
        case "pt":
        case "pt-BR":
        case "pt-PT":
            return "pt"
        case "ro":
        case "ro-RO":
            return "ro"
        case "ar":
        case "ar-SA":
        case "ar-IQ":
        case "ar-EG":
        case "ar-LY":
        case "ar-DZ":
        case "ar-MA":
        case "ar-TN":
        case "ar-OM":
        case "ar-YE":
        case "ar-SY":
        case "ar-JO":
        case "ar-LB":
        case "ar-KW":
        case "ar-AE":
        case "ar-BH":
        case "ar-QA":
            return "ar"
        case "nl":
        case "nl-NL":
        case "nl-BE":
            return "nl"
        case "tr":
        case "tr-TR":
            return "tr"
        default:
            return "en"
    }
}

export const getDirection = () => {
    return getLocale() === "ar" ? "rtl" : "ltr";
}

export function getMessages() {
    const locale = getLocale();
    const lang =  {
        "de": intlMessageDE,
        "en": intlMessageEN,
        "es": intlMessageES,
        "fr": intlMessageFR,
        "hi": intlMessageHI,
        "it": intlMessageIT,
        "ja": intlMessageJP,
        "pt": intlMessagePT,
        "nl": intlMessageNL,
        "tr": intlMessageTR,
        "ro": intlMessageRO,
        "ar": intlMessageAR,
    }
    return lang[locale];
}